import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Spinner from 'react-bootstrap/Spinner';
import { Container } from 'react-bootstrap';

import { TimelineOffCanvas } from '../components/TimelineOffCanvas';
import { useUiStore } from '../hooks/useUiStore';
import PredictionTimeline from '../components/Timeline/PredictionTimeline';
import { InsightsOffCanvas } from '../components/InsightsOffCanvas';
import { useLocation } from 'react-router-dom';
import {
  getPatientProfile,
  getPreTimeline,
  getTimeline,
  updateClinicianProfile,
} from '../../store/ai2';
import moment from 'moment';

const Predictions = (props) => {
  // timeline state from Redux store
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const access_token = searchParams.get('access_token');
  const { clinicianProfileStatus, selectedTenancy, dashSettings } = useSelector(
    (state) => state.clinicianProfile,
  );

  const dispatch = useDispatch();

  // Custom Hook for TimelineOffCanvas
  const { openInsightDetails, closeInsightDetails } = useUiStore();

  useEffect(() => {
    closeInsightDetails();
  }, []);

  useEffect(() => {
    clinicianProfileStatus &&
      dispatch(
        getPreTimeline(
          access_token,
          moment().add(0, 'year').format(),
          moment().add(5, 'year').format(),
          selectedTenancy,
        ),
      );
  }, [access_token, clinicianProfileStatus]);

  const saveDefaultZoom = (offset) => {
    const startDate = moment().subtract(offset, 'milliseconds').format();
    const days = moment().diff(startDate, 'day');
    dispatch(
      updateClinicianProfile({
        timelineZoom: { startValue: days < 7 ? 7 : days, startUnit: 'day' },
      }),
    );
  };

  const { groups, items, isLoading } = useSelector((state) => state.prediction);
  const startDate = moment();
  const endDate = moment().add(6, 'months');
  // state to check if open Insights or Timeline OffCanvas
  const [isInsightEvent, setIsInsightEvent] = useState(false);
  // Rendering //
  if (!isLoading) {
    return (
      <>
        <PredictionTimeline
          groups={groups}
          items={items}
          startDate={startDate}
          endDate={endDate}
          dashSettings={dashSettings}
          saveDefaultZoom={saveDefaultZoom}
          isSimple={true}
          openInsightDetails={openInsightDetails}
          closeInsightDetails={closeInsightDetails}
          setIsInsightEvent={setIsInsightEvent}
        />
        {!isInsightEvent && (
          <TimelineOffCanvas
            sendToParent={props.sendToParent}
            closeInsightDetails={closeInsightDetails}
          />
        )}
        {isInsightEvent && (
          <InsightsOffCanvas
            sendToParent={props.sendToParent}
          ></InsightsOffCanvas>
        )}
      </>
    );
  } else {
    return (
      <>
        <Container fluid>
          <div className="mySpinner">
            <div>
              <Spinner animation="border" role="status"></Spinner>
              <span>
                <br />
                Loading...
              </span>
            </div>
          </div>
        </Container>
      </>
    );
  }
};

export { Predictions };
